import { render, staticRenderFns } from "./RecoverPass.vue?vue&type=template&id=3e3a8b70&scoped=true"
import script from "./RecoverPass.vue?vue&type=script&lang=js"
export * from "./RecoverPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3a8b70",
  null
  
)

export default component.exports